let dragData = {
  isDragging: false,
  translateX: 0,
  translateY: 0,
  originalX: 0,
  originalY: 0,
};

interface Action {
  type: string;
  data: any;
}

export const reducer = (state: any, action: Action) => {
  const handleDragEnter = () => {
    let dropId = action.data.dropId;
    state.draggable.droppableId = dropId;
    state.droppableId = dropId;
    return state;
  };

  const handleDragLeave = () => {
    state.draggable.droppableId = null;
    state.draggable.droppableCoords = null;
    state.droppableId = null;
    return state;
  };

  const handleDrag = () => {
    let instance = state.draggable;
    if (instance) {
      instance.translateX = Math.round(action.data.x - instance.originalX);
      instance.translateY = Math.round(action.data.y - instance.originalY);

      if (action.data.droppableCoords) {
        instance.droppableCoords = action.data.droppableCoords;
      }

      state.draggable = instance;
    }

    return state;
  };

  switch (action.type) {
    case "drag_start":
      state.draggable = action.data;
      break;
    case "drag_end":
      state.draggable = undefined;
      state.droppableId = undefined;
      break;
    case "drag":
      return handleDrag();
    case "drag_enter":
      console.log("enter");
      return handleDragEnter();
    case "drag_leave":
      console.log("leave");
      return handleDragLeave();
    case "add_draggable":
      state.draggables[action.data.id] = action.data;
      break;
    case "reset_draggable":
      // drag.isDragging = false;
      // drag.translateX = 0;
      // drag.translateY = 0;
      // drag.originalX = 0;
      // drag.originalY = 0;
      state.currentDragId = null;
      state.currentDropId = null;
      return state;
      break;
    case "add_droppable":
      state.droppables[action.data.id] = action.data;
      break;
  }
};
